module.exports = __webpack_public_path__ + "img/videocam.4871e0ba.svg";